import * as React from "react";
import { forwardRef } from "react";
const SvgRedCross = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7 1L1 7", stroke: "#EB5757", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7 7L1 1", stroke: "#EB5757", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgRedCross);
export { ForwardRef as ReactComponent };
